import {
  FETCH_CREATE_TEMPLATE_FOLDER_REQUEST,
  FETCH_CREATE_TEMPLATE_FOLDER_SUCCESS,
  FETCH_CREATE_TEMPLATE_FOLDER_FALUIRE,
} from './createTemplateFolderTypes'

const initialState = {
  loading: false,
  createTemplateFolder: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_CREATE_TEMPLATE_FOLDER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_CREATE_TEMPLATE_FOLDER_SUCCESS : return {
      ...state,
      createTemplateFolder: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_CREATE_TEMPLATE_FOLDER_FALUIRE : return {
      ...state,
      loading: false,
      createTemplateFolder: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
